import {isNil, sumBy} from 'es-toolkit'

export enum MessagePlaceholder {
  ASK_FOR_REVIEW = 'askForReview',
}

export type MessagePlaceholderMap = Record<
  MessagePlaceholder,
  {
    replacement: string
    addition?: React.ReactNode
  }
>

const extractLinks = (message: string) => {
  const regex = /\n<a cc-link-type="([^"]*)".*?<\/a>/g

  const array = [...message.matchAll(regex)]
  const matches = array.map(match => ({linkText: match[0], linkType: match[1]}))

  return matches
}

export const getSanitizedMessageAndAdditions = (
  message: string,
  placeholderMap: MessagePlaceholderMap,
  onError: (reason: string) => void
) => {
  const messageLinkMatches = extractLinks(message)

  let sanitizedMessage = message
  let messageAdditions: React.ReactNode[] = []

  messageLinkMatches?.forEach(linkMatch => {
    const replacement = placeholderMap[linkMatch.linkType as MessagePlaceholder]
    if (isNil(replacement)) {
      onError(`Unknown link placeholder: ${linkMatch.linkType}`)
    } else {
      if (replacement.addition) {
        messageAdditions = [...messageAdditions, replacement.addition]
      }
      sanitizedMessage = sanitizedMessage.replace(linkMatch.linkText, replacement.replacement)
    }
  })

  return {
    sanitizedMessage,
    messageAdditions,
  }
}

export const sanitizeTextLineBreaks = (str: string) => str.replace(/(\r\n|\r)/g, '\n')

export const getCharacterCount = (str: string) => {
  const rawStringCount = str.length
  const linebreakMatches = str.match(/(\r\n|\n|\r)/g) || []
  const lineBreakCharactersCount = sumBy(linebreakMatches, (match: string) => {
    return match.length
  })
  const sum = rawStringCount + lineBreakCharactersCount
  return sum
}
